"use strict";

var _loadContentLink = require("./loadContentLink");

var _loadContentLink2 = _interopRequireDefault(_loadContentLink);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

var _dynamicLoadContent = require("./dynamicLoadContent");

var _dynamicLoadContent2 = _interopRequireDefault(_dynamicLoadContent);

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");

var resx = (0, _localize2.default)("Common");

var fileManagerService = abp.services.api.filemanager;

function createBreadcrumb(id, name, modalSelector, imageType) {
    var className = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "breadcrumb";

    var html = "";
    if (imageType === "AdminFiles") {
        id = id === null ? "/FileManager/Edit" : id;
        html = "<a href=\"" + id + "\">" + name + "</a>";
    } else {
        html = (0, _loadContentLink2.default)(id, name, modalSelector + " .modal-content", "/FileManager/ChooseImage/?folderId=" + id + "&fileImageType=" + imageType);
    }

    return "<span class=\"" + className + "\">" + html + "</span>";
}

function fileManagerBreadcrumbs() {
    var breadcrumbSelector = "div[data-toggle='fileManagerBreadcrumbs'][data-folder-id][data-modal-selector]";

    $(breadcrumbSelector).each(function (i, el) {
        var $t = $(el);
        var folderId = $t.data("folder-id");
        var modalSelector = $t.data("modal-selector");
        var imageType = $t.data("image-type");

        fileManagerService.getBreadcrumbs(folderId).done(function (result) {
            var htmlResult = createBreadcrumb(null, "<span><i class='fa fa-home' /></span>", modalSelector, imageType);

            result.forEach(function (folder) {
                htmlResult += createBreadcrumb(folder.key, folder.value, modalSelector, imageType);
            });

            // only show Back button when we have folders in breadcrumbs 
            if (result && result.length > 0) {
                var prevFolderId = null;
                if (result.length >= 2) {
                    prevFolderId = result[result.length - 2].key;
                }
                htmlResult += createBreadcrumb(prevFolderId, resx.Common.ParentFolder || 'Zpět', modalSelector, imageType, "breadcrumbsBtn btn btn-sm");
            }

            $t.html(htmlResult);
            (0, _dynamicLoadContent2.default)(breadcrumbSelector + " a[data-toggle='load'][data-target]");
        }).fail(function (err) {
            _notify2.default.error(L(err.responseJSON.error.message));
        });
    });
}

module.exports = exports.default = function () {
    fileManagerBreadcrumbs();
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/fileManagerBreadcrumbs.js
// module id = 434
// module chunks = 0